import { render, staticRenderFns } from "./CallLetter.vue?vue&type=template&id=39c3e27c&"
import script from "./CallLetter.vue?vue&type=script&lang=js&"
export * from "./CallLetter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports